




















import Vue from 'vue';
import Component from 'vue-class-component';
import isEqual from 'lodash.isequal';
import isUndefined from 'lodash.isundefined';
import isNull from 'lodash.isnull';
import genericapi  from '../assets/ts/genericAPIAxios';
// Vue.prototype.$genericapi = genericapiinstance;

@Component
export default class ReprocessEbiennialFromPaymentComponent extends Vue {
  private showMaintenanceBanner : boolean = false;
  private maintenanceBannerMessage:string = '';
  private DOSIDNumber: string = '';
  private BusinessName: string = '';
  private errors = [];
  private label = [];
  private configurationName: string = 'PAYMENT';
  private imageFolderPath: string = '';
  private SubmitterInfo: any = {};
  private filingResponse: any = {};
  private validationConfigurationFromDB=[];
  private errorMessagesFromDB=[];
  private MessageToUser:string = "Fetching records and processing in a new window for each failed transaction.";
  // private genericInstance = this.$genericapi;

  private created() {
    console.log('Inside created of first page');
    //this.$store.commit('ebiennial/setEBiennialData', null);
    if (this.empty(this.label) || this.label.length === 0) {
     this.fetchLabels().then((labelResponse: any) => {
       console.log(labelResponse);
       this.label = labelResponse;
        // console.log('first pragraph:'+this.label.EBIENNIAL_HOME_PARAGRAPH_1);
      });
    }
    console.log('Fetching configuration from database');
    genericapi.get('Generic/GetConfigurationData', {
      params: {
      group: 'CONFIGURATION',
      application: 'EBIENNIAL',
    },

    }).then((response: any) => {
      console.log(response);
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });
    
    console.log('Fetching error messages from database');
    genericapi.get('Generic/GetConfigurationData', {
      params: {
      group: 'ERROR',
      application: 'EBIENNIAL',
    },

    }).then((response: any) => {
      console.log(response);
      this.errorMessagesFromDB = response.data;
      console.log('after getting the error values from database');
      console.log(this.errorMessagesFromDB);
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });

    //var url = "https://dev-apps.dos.ny.gov/eBiennialWeb/confirmation?ssl_amount=9.00&ssl_card_short_description=VISA&merchant_defined_data2=13240&merchant_defined_data1=325&ssl_avs_address=28+LIBERTY+ST.&ssl_state=NY&ssl_last_name=SYSTEM&ssl_approval_code=917558&ssl_avs_zip=10005&uid=00d33c2b-f218-4342-ad64-9590dffeb574&show_merchant_id=true&ssl_exp_date=1122&ssl_country=USA&ssl_city=NEW+YORK&ssl_first_name=C&ssl_invoice_number=325&application_profile_id=4&ssl_txn_id=090721ED4-DDF27452-813D-473E-AF57-F49A789AE26E&ssl_transaction_type=SALE&ssl_result=0&ssl_result_message=APPROVAL&ssl_card_number=48**********7774&ssl_avs_response=A&ssl_cvv2_response=M&ssl_txn_time=07%2F09%2F2021+03%3A27%3A29+PM";
    //window.open(url,'mywindow');

    const store = this.$store;
    const http = this.$http;
    http.get('Ebiennial/ReprocessEbiennialFromPayment', {
          }).then((response: any) => {
            console.log('after getting response from PSS');
            console.log(response);
            console.log(response.data);
            if(Object.keys(response.data).length != 0){
              console.log('data is not null and now iterating')
              response.data.forEach((element, index) => 
                window.open(element,'mywindow'+index)
              );
            }
            this.MessageToUser = "Completed processing records from PSS";
    }).catch((error: any) => {
      // this.error = error
      console.log(error);
      this.MessageToUser = "There was an error processing records from PSS. Either no records found or an error occured.";
      //this.errors.push(error);
    });
    console.log('imageFolderPath:' + this.imageFolderPath);
  }

  private getConfigurationValue(keyValue: string): string {
  console.log('keyValue passed:' + keyValue);
  for (let i = 0; i < this.validationConfigurationFromDB.length; i++) {
      for (const key in this.validationConfigurationFromDB[i] ) {
        //console.log( key + ' == ' +  this.errorsMessagesFromDB[i][key]);
        if (key === keyValue) {
          console.log('Matched if:'+this.validationConfigurationFromDB[i][key]);
          return this.validationConfigurationFromDB[i][key];
        }

      }
  }
}

  private getErrorMessage(keyValue: string): string {
  console.log('keyValue passed:' + keyValue);
  for (let i = 0; i < this.errorMessagesFromDB.length; i++) {
      for (const key in this.errorMessagesFromDB[i] ) {
        if (key === keyValue) {
          console.log('Matched if:'+this.errorMessagesFromDB[i][key]);
          return this.errorMessagesFromDB[i][key];
        }

      }
  }
}


private getLabelValue(keyPassed: string) {
    for (let i = 0; i < this.label.length; i++) {
      for (const key in this.label[i] ) {
        if (key === keyPassed) {
          console.log('Matched if');
          return this.label[i][key];
        }

      }
    }
    // console.log('label value:'+this.label[keyPassed]);
    // return this.label[keyPassed];
  }
  private getImageURL(columnname: string) {
     const images = require.context('@/assets/images/', true, /\.jpg$/);
     return images('./' + this.getLabelValue(columnname));
    // return this.getLabelValue(columnname);
  }
  private fetchLabels() {
     // return this.$http.get('Ebiennial/GetConfigurationData', {
      //  return genericapi.get('Ebiennial/GetConfigurationData', {
        return genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'SECTION',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);

      // console.log('key value:'+response.data.values[response.data.map(function(o) { return o.key; }).indexOf('EBIENNIAL_HOME_PARAGRAPH_1')]);
      return response.data;
    }).catch((error: any) => {
      console.log(error);
    });
  }
  private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case typeof this === undefined:
      return true;
      default:
        return false;
    }
  }
 }
